// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1qJmR","vLegacy":"SelectSecondary_vLegacy__2fj6y","error":"SelectSecondary_error__3qJd8","disabled":"SelectSecondary_disabled__19-z2"};